import styles from "./PropertyPhotoManager.module.css";
import Text from "../UI/Text";
// @ts-expect-error pure js
import { DocType } from "../../utils/constants/documents.js";
import FileInput from "../UI/FileInput";
import usePropertyPhotos, {
  type PropertyPhoto,
} from "../../hooks/use-property-photos";
import SortablePhotoGrid from "../UI/SortablePhotoGrid";
// @ts-expect-error pure js
import DocumentThumbnail from "../UI/DocumentThumbnail";
import DocumentDownloadLink from "../UI/DocumentDownloadLink";
// @ts-expect-error pure js
import { classnames } from "../../utils";

interface PropertyPhotoManagerProps {
  propertyId: number;
  isFolder?: boolean;
  className?: string;
}

export default function PropertyPhotoManager({
  propertyId,
  isFolder = false,
  className,
}: PropertyPhotoManagerProps) {
  const { photos, deletePhoto, reorderPhotos } = usePropertyPhotos(
    propertyId,
    isFolder,
  );

  return (
    <div className={classnames(styles.container, className)}>
      <Text>
        Photos du bien <br />
        {photos.length > 0 && (
          <Text variant="deci" as="span" className={styles.hint}>
            Glissez-déposez pour réorganiser. La première photo sera utilisée
            comme photo principale par défaut.
          </Text>
        )}
      </Text>

      <SortablePhotoGrid
        items={photos}
        getId={(photo) => photo.id}
        onReorder={(reordered: PropertyPhoto[]) =>
          reorderPhotos(reordered.map((photo) => photo.id))
        }
      >
        {(photo, i) => (
          <DocumentDownloadLink
            documentId={photo.id}
            doctype={DocType.PROPERTY_PHOTO}
            file={photo}
          >
            <DocumentThumbnail
              documentId={photo.id}
              doctype={DocType.PROPERTY_PHOTO}
              file={photo}
              alt={`Photo du bien ${i + 1}`}
              onDelete={() => deletePhoto(photo.id)}
            />
          </DocumentDownloadLink>
        )}
      </SortablePhotoGrid>

      <FileInput
        path="_pendingPhotos"
        doctype={DocType.PROPERTY_PHOTO}
        multiple
        accept="image/*"
        format="Format PNG, JPG, JPEG"
        text="Ajouter des photos"
      />
    </div>
  );
}
